(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-play/assets/react/components/play-page-container.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-play/assets/react/components/play-page-container.js');

'use strict';

const {
  useEffect
} = React;
const {
  useAtomValue
} = jotai;
const {
  pinLocationAtom,
  shouldShowPinAtom,
  locationConfirmedAtom
} = svs.lyckoplatsen.components.page_play.jotai.atoms;
const {
  charityAtom
} = svs.lyckoplatsen.shared_charity.jotai.atoms;
const {
  isMovingAtom,
  isUserIdleAtom,
  mapZoomLevelAtom
} = svs.lyckoplatsen.shared_map.atoms;
const {
  CONSTANTS
} = svs.lyckoplatsen.components.shared_constants;
const PlayPageContainer = _ref => {
  let {
    children
  } = _ref;
  const locationConfirmed = useAtomValue(locationConfirmedAtom);
  const pinLocation = useAtomValue(pinLocationAtom);
  const shouldShowPin = useAtomValue(shouldShowPinAtom);
  const isUserIdle = useAtomValue(isUserIdleAtom);
  const zoomLevel = useAtomValue(mapZoomLevelAtom);
  const isMoving = useAtomValue(isMovingAtom);
  const charity = useAtomValue(charityAtom);
  const isNativeApp = svs.utils.ns.isNamespace('svs.core.config.data.svsconfig.isNativeApp', window) && svs.core.config.data.svsconfig.isNativeApp;
  const hasMobileKeyboard = svs.lyckoplatsen.hooks.useMobileKeyboardDetect();
  const classNames = ['lp-page-play lp-page-grow'];
  if (zoomLevel >= CONSTANTS.PLACE_PIN_ZOOM_LEVEL) {
    classNames.push('place-pin-zoom-level');
  }
  if (shouldShowPin) {
    classNames.push('showing-pin');
  }
  if (locationConfirmed) {
    classNames.push('has-confirmed-location');
  }
  if (pinLocation.lat) {
    classNames.push('has-pin-location');
  }
  if (isMoving) {
    classNames.push('map-is-moving');
  }
  if (isUserIdle) {
    classNames.push('lp-user-is-idle');
  }
  if (charity) {
    classNames.push('charity-selected');
  }
  if (isNativeApp) {
    classNames.push('is-native-app');
  }
  if (hasMobileKeyboard) {
    classNames.push('has-mobile-keyboard');
  }
  useEffect(() => {
    svs.lyckoplatsen.utils.ui.hideFooter();
    return svs.lyckoplatsen.utils.ui.showFooter;
  }, []);
  return React.createElement("div", {
    className: " ".concat(classNames.join(' '))
  }, children);
};
setGlobal('svs.lyckoplatsen.components.page_play.react.components', {
  PlayPageContainer
});

 })(window);